export default {
	title: 'Bien vivre ma grossesse',
	articles: {
		mois0: [
			1,3,4,8,2,7,6,5
		],
		mois1: [
			1,3,4,8,2,7,6,5
		],
		mois2: [
			1,3,4,8,2,7,6,5
		],
		mois3: [
			1,3,4,9,2,7,6,5
		],
		mois4: [
			1,3,4,9,2,7,6,5
		],
		mois5: [
			1,3,4,9,2,7,6,5
		],
		mois6: [
			1,3,4,9,2,7,6,5
		],
		mois7: [
			1,3,4,9,2,7,6,5
		],
		mois8: [
			1,3,4,10,2,7,6,5
		],
		mois9: [
			1,3,4,10,2,7,6,5
		]
	}
};
